import { useCallback } from 'react';
import Helmet from 'react-helmet'
import { useParams } from 'react-router-dom'

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history'

import Form from '../components/Form'
import { MetaFieldProvider, useMetaFieldStore } from '../store';

const MetaFieldForm = () => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit } } = useMetaFieldStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleCloseSidebar = useCallback(() => {
    history.push('/settings/meta-fields')
  }, [])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      handleCloseSidebar()
      handleSuccess('Success', `Meta Field ${payload.id ? 'edited' : 'created'}.`)
    } catch {
      handleError('Error', 'Meta Field was not saved.')
    }
  }, [handleSubmit, handleCloseSidebar, handleSuccess, handleError])

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleCloseSidebar() }}
      contentProps={{ size: 'sm' }}
      title={item.id ? 'Edit Meta Field' : 'Add Meta Field'}
    >
      <Helmet title='Meta Field' />
      <Form data={item} onSubmit={handleSubmitAndClose} onCancel={handleCloseSidebar} />
    </DefaultSheet>
  </>
}

export default function MetaFieldFormLayout() {
  return <MetaFieldProvider>
    <MetaFieldForm />
  </MetaFieldProvider>
}
